
        var result = require("!!../../../../../node_modules/css-loader/index.js!./belpex-overview.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/belpex/belpex-overview/belpex-overview.component.css
// module id = 628
// module chunks = 0